import type { ControlSize } from '@/shared/ui/core/types';

export const controlHeightClass: Record<ControlSize, string> = {
  sm: 'h-[var(--control-height-dense)] min-h-[var(--control-height-dense)]',
  md: 'h-[var(--control-height-md)] min-h-[var(--control-height-md)]',
  lg: 'h-[var(--control-height-default)] min-h-[var(--control-height-default)]',
  touch: 'h-[var(--control-height-touch)] min-h-[var(--control-height-touch)]',
};

/** Single 1px border — no outline/ring (global :focus-visible is suppressed). */
export const fieldFocusClass =
  'outline-none focus-visible:border-primary focus-visible:outline-none focus-visible:ring-0';

export const fieldBaseClass =
  'w-full rounded-input border bg-surface text-text text-body font-sans outline-none transition-colors ' +
  'placeholder:text-text-muted ' +
  fieldFocusClass +
  ' ' +
  'disabled:cursor-not-allowed disabled:bg-disabled-bg disabled:text-disabled-fg disabled:border-disabled-border ' +
  'read-only:bg-readonly-bg read-only:text-readonly-fg';

export const fieldBorderClass = {
  default: 'border-border-strong',
  error: 'border-danger',
} as const;

export const labelClass = 'text-caption font-semibold text-text';
export const hintClass = 'text-caption text-text-secondary';
export const errorClass = 'text-caption text-danger-fg';
